exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-button[data-v-71e68f1c] {\n  background-color: #DFDFDF;\n  border: none;\n  border-radius: 6px;\n  font-weight: bold;\n  width: 200px;\n  height: 40px;\n  font-size: 14px;\n  cursor: pointer;\n  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71e68f1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/atoms/LoginButton.vue
// module id = AyhI
// module chunks = 3